import './tutorialrecordflows.css'

import React from 'react'
import {
	IonButton,
	IonButtons,
	IonContent,
	IonHeader,
	IonIcon,
	IonModal,
	IonToolbar,
} from '@ionic/react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination } from 'swiper/modules'

import tutorialGoalButton from './media/tutorial-goal-button.png'
import tutorialEndQtrButton from './media/tutorial-end-qtr-button.png'
import tutorialRecordTurnovers from './media/tutorial-record-turnovers.mp4'
import tutorialUndoButton from './media/tutorial-undo-button.png'
import tutorialChangeButton from './media/tutorial-change-button.png'
import 'swiper/css'
import 'swiper/css/pagination'
import {arrowForwardOutline} from 'ionicons/icons'
import {FlowInviteGallery} from './FlowInviteUpsell'

const getRecordFlowsHelpSlides = (onDismiss: () => void) => [
	{
		title: 'Turnovers, goals, ends of quarters.',
		copy: (
            <>
                <p>
                    That's all you need to notice.
                </p>
                <p>
                    Swipe <IonIcon icon={arrowForwardOutline} className="swipe-right" />
                </p>
            </>
            ),
	},
	{
		title: '1. Turnovers',
		copy: (
            <>
                <p>
                    Whenever one team gains possession from the other, tap <b>the zone where it happened</b>.
                </p>
                <div className="video-container">
                    <video playsInline autoPlay muted loop>
                        <source src={tutorialRecordTurnovers} type="video/mp4" />
                    </video>
                </div>
                <p className="tutorial-record-flows-tip">
                    Tip: If it's anywhere near the midcourt, call it the midcourt.
                </p>
            </>
        ),
	},
	{
		title: '2. Goals',
        copy: (
            <>
                <p>
                    When a goal is scored, tap the Goal button.
                </p>
                <p>
                    <img src={tutorialGoalButton} alt="Goal" className="tutorial-goal-button" />
                </p>
                <p className="tutorial-record-flows-tip">
                    Super Shot? Long-press the Goal button.
                </p>
            </>
        ),
	},
    {
        title: '3. Ends of quarters',
        copy: (
            <>
                <p>
                    When a quarter ends, tap the End Quarter button.
                </p>
                <p>
                    <img src={tutorialEndQtrButton} alt="End Quarter" className="tutorial-goal-button" />
                </p>
                <p>
                    Sometimes you'll be asked whether a centre pass was taken after the most recent goal.
                </p>
            </>
        ),
	},
	{
		title: 'Wrong tap?',
        copy: (
            <>
                <p>
                    Use <b>Undo</b> and <b>Redo</b> to fix mistakes.
                </p>
                <p>
                    <img src={tutorialUndoButton} alt="Undo / Redo" className="tutorial-goal-button" />
                </p>
                <p>
                    If the centre pass team is wrong, tap <b>Change</b>.
                </p>
                <p>
                    <img src={tutorialChangeButton} alt="Change" className="tutorial-goal-button" />
                </p>
            </>
        ),
	},
    {
        title: "That’s it!",
        copy: (
            <>
                <FlowInviteGallery />
                <p>
                    You're providing real-time ball movement insights to your team.
                </p>
				<p>
					<IonButton
						fill="outline"
						onClick={onDismiss}
					>
						Get Started
					</IonButton>
                </p>
            </>
        ),
	},

]

const TutorialRecordFlowsModal = (props: {
	isOpen: boolean
	onDismiss: () => void
}) => {
	const { isOpen, onDismiss } = props
	const slides = getRecordFlowsHelpSlides(onDismiss)

	return (
		<IonModal
			className="record-flows-help-modal"
			isOpen={isOpen}
			onDidDismiss={onDismiss}
		>
			<IonHeader>
				<IonToolbar>
					<IonButtons slot="end">
						<IonButton onClick={onDismiss}>
							Close
						</IonButton>
					</IonButtons>
				</IonToolbar>
			</IonHeader>
			<IonContent className="record-flows-help-content">
				<Swiper
					className="record-flows-help-swiper"
					pagination={{ clickable: true }}
					modules={[ Pagination ]}
				>
					{slides.map(slide => (
						<SwiperSlide key={slide.title}>
							<RecordFlowsHelpSlide
								title={slide.title}
								copy={slide.copy}
							/>
						</SwiperSlide>
					))}
				</Swiper>
			</IonContent>
		</IonModal>
	)
}

const RecordFlowsHelpSlide = (props: {
	title: string
	copy: string|React.JSX.Element
}) => {
	const { title, copy } = props

	return (
		<section className="record-flows-help-slide">
			<div className="record-flows-help-kicker">How to Record</div>
			<h2>{title}</h2>
			{copy}
		</section>
	)
}

export default TutorialRecordFlowsModal
